import { RouteState } from './appStateTypes';

export const STORAGE_KEYS = {
  SELECTED_CANDIDATE_ID: 'selectedCandidateId',
  SELECTED_JOB_ID: 'selectedJobId',
  SELECTED_EMPLOYER_ID: 'selectedEmployerId',
  LAST_ROUTE: 'lastVisitedRoute',
  ROUTE_STATE: 'routeState',
  ACTIVE_TAB: 'activeTab',
  APPLIED_FILTERS: 'appliedFilters',
  SIDEBAR_COLLAPSED: 'sidebarCollapsed',
} as const;

export function getStoredId(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.warn('Failed to read from localStorage:', error);
    return null;
  }
}

export function setStoredId(key: string, id: string | null): void {
  try {
    if (id) {
      localStorage.setItem(key, id);
    } else {
      localStorage.removeItem(key);
    }
  } catch (error) {
    console.warn('Failed to write to localStorage:', error);
  }
}

export function getStoredObject<T>(key: string, defaultValue: T): T {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : defaultValue;
  } catch (error) {
    console.warn(`Failed to read ${key} from localStorage:`, error);
    return defaultValue;
  }
}

export function setStoredObject(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn(`Failed to write ${key} to localStorage:`, error);
  }
}

export function getInitialRouteState(): RouteState {
  return {
    lastRoute: getStoredId(STORAGE_KEYS.LAST_ROUTE),
    activeTab: getStoredId(STORAGE_KEYS.ACTIVE_TAB),
    appliedFilters: getStoredObject(STORAGE_KEYS.APPLIED_FILTERS, {}),
    sidebarCollapsed: getStoredObject(STORAGE_KEYS.SIDEBAR_COLLAPSED, false),
  };
}

export function persistRouteState(routeState: RouteState): void {
  setStoredId(STORAGE_KEYS.LAST_ROUTE, routeState.lastRoute);
  setStoredId(STORAGE_KEYS.ACTIVE_TAB, routeState.activeTab);
  setStoredObject(STORAGE_KEYS.APPLIED_FILTERS, routeState.appliedFilters);
  setStoredObject(STORAGE_KEYS.SIDEBAR_COLLAPSED, routeState.sidebarCollapsed);
}

export function clearStoredRouteState(): void {
  localStorage.removeItem(STORAGE_KEYS.LAST_ROUTE);
  localStorage.removeItem(STORAGE_KEYS.ACTIVE_TAB);
  localStorage.removeItem(STORAGE_KEYS.APPLIED_FILTERS);
  localStorage.removeItem(STORAGE_KEYS.SIDEBAR_COLLAPSED);
}
